module.exports = __webpack_public_path__ + "img/2left-de762c2d.png";